// export const defaultBaseUrl = 'http://api.boatpark.local/v2.4';
// export const defaultBaseUrl = 'https://dev.api.boatpark.app/v2.4';
export const defaultBaseUrl =
   process.env.REACT_APP_API_BASE_URL ?? 'https://api.boatpark.app/v2.10';
